var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "card-field-container" },
        [
          _c("div", { staticClass: "label-oos mb-4" }, [_vm._v("Config")]),
          _vm._v(" "),
          _vm.showPageForm
            ? _c("j-form-page", {
                ref: "formEditPage",
                attrs: {
                  mode: "edit",
                  "is-popover": false,
                  "data-page": _vm.data_general,
                  "icon-options": _vm.icon_options
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.showPageForm
            ? _c("div", { staticClass: "d-flex mt-3" }, [
                _c(
                  "button",
                  { staticClass: "btn-blue", on: { click: _vm.updateGeneral } },
                  [_vm._v("\n        Update\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "cursor-pointer mt-2 ml-3",
                    on: { click: _vm.deleteThisPage }
                  },
                  [
                    _c("i", { staticClass: "fa fa-trash" }),
                    _vm._v(" Delete this page\n      ")
                  ]
                )
              ])
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.dataPage.type === "visible" || _vm.dataPage.type === "invisible"
        ? _c(
            "div",
            {
              staticClass: "pb-3",
              staticStyle: {
                "max-height": "calc(100vh - 474px)",
                "overflow-x": "auto"
              }
            },
            [
              _vm.isLoading
                ? _c(
                    "div",
                    { attrs: { id: "component-list" } },
                    [_c("j-skeleton-component")],
                    1
                  )
                : _c(
                    "div",
                    { attrs: { id: "component-list" } },
                    [
                      _vm.listComponent.length === 0
                        ? _c("h5", [_vm._v("No component on this page")])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.listComponent, function(component, index) {
                        return _c(
                          "div",
                          {
                            key: component.id,
                            staticClass: "component-list",
                            class: {
                              selected:
                                _vm.dataEdit &&
                                _vm.dataEdit.id === component.id,
                              canvas: component.type === "canvas"
                            }
                          },
                          [
                            component.type === "form_ui" ||
                            component.type === "multiple_form_ui"
                              ? [
                                  component.info &&
                                  JSON.parse(component.info).default_view ===
                                    "table_view"
                                    ? _c("dummy-table-view", {
                                        attrs: { "data-component": component }
                                      })
                                    : component.info &&
                                      JSON.parse(component.info)
                                        .default_view === "table_requester_view"
                                    ? _c("dummy-table-view", {
                                        attrs: {
                                          "data-component": component,
                                          type: "requestor"
                                        }
                                      })
                                    : component.info &&
                                      JSON.parse(component.info)
                                        .default_view === "table_approver_view"
                                    ? _c("dummy-table-view", {
                                        attrs: {
                                          "data-component": component,
                                          type: "approver"
                                        }
                                      })
                                    : component.info &&
                                      JSON.parse(component.info)
                                        .default_view === "create_view"
                                    ? _c("dummy-create-detail-view", {
                                        attrs: {
                                          "data-component": component,
                                          type: "create"
                                        }
                                      })
                                    : component.info &&
                                      JSON.parse(component.info)
                                        .default_view === "detail_view"
                                    ? _c("dummy-create-detail-view", {
                                        attrs: {
                                          "data-component": component,
                                          type: "detail"
                                        }
                                      })
                                    : component.info &&
                                      JSON.parse(component.info)
                                        .default_view === "calendar_view"
                                    ? _c("dummy-calendar-view", {
                                        attrs: { "data-component": component }
                                      })
                                    : component.info &&
                                      JSON.parse(component.info)
                                        .default_view === "export_view"
                                    ? _c("dummy-export-view", {
                                        attrs: { "data-component": component }
                                      })
                                    : _vm._e()
                                ]
                              : component.type === "html"
                              ? _c("dummy-html", {
                                  attrs: { "data-component": component }
                                })
                              : component.type === "canvas"
                              ? _c("dummy-canvas", {
                                  attrs: { "data-component": component }
                                })
                              : component.type === "attendance_my_log"
                              ? _c("dummy-attendance-my-log", {
                                  attrs: { "data-component": component }
                                })
                              : component.type === "attendance_monitor"
                              ? _c("dummy-attendance-monitor", {
                                  attrs: { "data-component": component }
                                })
                              : component.type === "attendance_report"
                              ? _c("dummy-attendance-report", {
                                  attrs: { "data-component": component }
                                })
                              : component.type === "attendance_config"
                              ? _c("dummy-attendance-config", {
                                  attrs: { "data-component": component }
                                })
                              : component.type === "co_attendance_requestor" ||
                                component.type === "co_attendance_approver"
                              ? _c("dummy-co-attendance", {
                                  attrs: {
                                    "data-component": component,
                                    type:
                                      component.type ===
                                      "co_attendance_requestor"
                                        ? "requestor"
                                        : "approver"
                                  }
                                })
                              : component.type === "leave_requestor" ||
                                component.type === "leave_approver" ||
                                component.type === "leave_monitor"
                              ? _c("dummy-leave", {
                                  attrs: {
                                    "data-component": component,
                                    type: component.type.split("_")[1]
                                  }
                                })
                              : component.type === "leave_config"
                              ? _c("dummy-leave-config", {
                                  attrs: { "data-component": component }
                                })
                              : component.type === "leave_report"
                              ? _c("dummy-leave-report", {
                                  attrs: { "data-component": component }
                                })
                              : component.type === "overtime_config"
                              ? _c("dummy-overtime-config", {
                                  attrs: { "data-component": component }
                                })
                              : component.type === "overtime_requestor" ||
                                component.type === "overtime_approver" ||
                                component.type === "overtime_monitor"
                              ? _c("dummy-overtime", {
                                  attrs: {
                                    "data-component": component,
                                    type: component.type.split("_")[1]
                                  }
                                })
                              : component.type === "overtime_report"
                              ? _c("dummy-overtime-report", {
                                  attrs: { "data-component": component }
                                })
                              : component.type === "timesheet_config"
                              ? _c("dummy-timesheet-config", {
                                  attrs: { "data-component": component }
                                })
                              : component.type === "timesheet_report"
                              ? _c("dummy-timesheet-report", {
                                  attrs: { "data-component": component }
                                })
                              : component.type === "timesheet_approval"
                              ? _c("dummy-timesheet-approval", {
                                  attrs: { "data-component": component }
                                })
                              : component.type === "employee_setup"
                              ? _c("dummy-employee-setup", {
                                  attrs: { "data-component": component }
                                })
                              : component.type === "user_setup"
                              ? _c("dummy-user-setup", {
                                  attrs: { "data-component": component }
                                })
                              : component.type === "access_management"
                              ? _c("dummy-access-management", {
                                  attrs: { "data-component": component }
                                })
                              : component.type === "embed_url"
                              ? _c("dummy-embed-url", {
                                  attrs: { "data-component": component }
                                })
                              : component.type === "hierarchy" ||
                                component.type === "custom_hierarchy"
                              ? _c("dummy-hierarchy", {
                                  attrs: {
                                    "data-component": component,
                                    "is-custom":
                                      component.type === "custom_hierarchy"
                                  }
                                })
                              : _c(
                                  "div",
                                  { staticClass: "pt-4" },
                                  [
                                    _c("j-skeleton-component", {
                                      attrs: { length: 1 }
                                    })
                                  ],
                                  1
                                ),
                            _vm._v(" "),
                            _c("div", { staticClass: "opentab-or-config" }, [
                              _c("div", { staticClass: "button" }, [
                                component.type === "form_ui" ||
                                component.type === "multiple_form_ui" ||
                                component.type === "canvas"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "open-tab",
                                        on: {
                                          click: function($event) {
                                            _vm.onOpenNewtab(component)
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-external-link"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "tooltip-component" },
                                          [_vm._v("Open new tab")]
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "edit",
                                    on: {
                                      click: function($event) {
                                        _vm.onClickEdit(index)
                                      }
                                    }
                                  },
                                  [
                                    _c("i", { staticClass: "fa fa-edit" }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "tooltip-component" },
                                      [_vm._v("Edit component")]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "delete",
                                    on: {
                                      click: function($event) {
                                        _vm.onClickDelete(index)
                                      }
                                    }
                                  },
                                  [
                                    _c("i", { staticClass: "fa fa-trash" }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "tooltip-component" },
                                      [_vm._v("Delete component")]
                                    )
                                  ]
                                )
                              ])
                            ])
                          ],
                          2
                        )
                      })
                    ],
                    2
                  ),
              _vm._v(" "),
              !_vm.modeCreate
                ? _c(
                    "div",
                    {
                      staticClass: "add-component-app",
                      attrs: { id: "popover-button-event" },
                      on: { click: _vm.toogle }
                    },
                    [_vm._v("\n      + Add Component\n    ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.opened,
                      expression: "opened"
                    }
                  ],
                  staticClass: "card-master-container"
                },
                [
                  _c("j-input", {
                    staticClass: "p--10",
                    attrs: { "error-required": false, placeholder: "Search" },
                    model: {
                      value: _vm.filter_data,
                      callback: function($$v) {
                        _vm.filter_data = $$v
                      },
                      expression: "filter_data"
                    }
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.data_component, function(val, index) {
                    return _c("div", { key: index }, [
                      _c(
                        "div",
                        {
                          staticClass: "cursor-dropdown",
                          on: {
                            click: function($event) {
                              _vm.chooseMaster(val)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(val.name_master.toUpperCase()) +
                              "\n        "
                          )
                        ]
                      )
                    ])
                  })
                ],
                2
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalForm",
          staticClass: "mod-form modal-pages-component",
          attrs: {
            centered: "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": "",
            "no-stacking": ""
          }
        },
        [
          _vm.showModalForm
            ? _c("j-pages-form-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "data-edit": _vm.dataEdit,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit
                },
                on: { "close-modal": _vm.closeModalForm }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37b758c1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37b758c1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/jPagesSetting.vue
// module id = null
// module chunks = 